import React, { useState, useRef, useEffect } from 'react';
import axios from "axios";
import {AWS_SERVER_APIS_issue} from "../configurations";
import {useDispatch, useSelector} from "react-redux";
const callbackTypes = {};

function App() {
  const [logMessages, setLogMessages] = useState(['Click Launch to start']);
  const [loginUsername, setLoginUsername] = useState('');
  const [loginContact, setLoginContact] = useState('');
  const [passcode, setPasscode] = useState('');
  const [homeId, setHomeId] = useState('');
  const [clientId, setClientId] = useState(null);
  const [iframeLoaded, setIframeLoaded] = useState(false);
  let myDomain = null;
  

  const testDivRef = useRef(null);
  const iframeRef = useRef(null);

    const {userRole} =
      useSelector(state => ({
          userRole: state.userRole?.filter(role => role.module === "Behaviour & Monitoring")
    }));

  const log = (message) => {
    setLogMessages(prevMessages => [...prevMessages, message]);
  };

  const start = () => {
    log('Iframe launched. Running SeniorMatics...');
    createAnIframe(testDivRef.current, callbackAfterCreateIframe, "https://dev.grand-app.com");
  };

  const callbackAfterCreateIframe = (clientId) => {
    log('callbackAfterCreateIframe ' + clientId);
    setClientId(clientId);
  };

  const onLogin = () => {
    var loginUsername = document.getElementById("loginUsername").value;
    var loginContact = document.getElementById("loginContact").value;
    loginToSeniorMatics(loginUsername, loginContact, callbackAfterLogin);
  };

  const callbackAfterLogin = (result) => {
    log("Login information sent " + result.o.b);
  };

  const onPasscode = () => {
    loginWithPasscodeToSeniorMatics(passcode, callbackPasscode);
  };

  const callbackPasscode = (result) => {
    log("Passcode sent " + result);
  };

  const onGoHome = () => {
    navigateToHome(homeId, callbackHome);
  };

  const callbackLoadPage = () => {
    log('Fill Login data');
  };

  const callbackLaunch = () => {
    log('Wait for loading home page...');
  };

  const callbackRegistration = () => {
    log("Get passcode using Phone or Email login data, fill it in Passcode field");
  };

  const callBackAfterSuccessfulLogin = (pageName) => {
    log("SeniorMatics page loaded, page name: " + pageName);
    if (pageName === "disclaimer") {
      log("Read and accept disclaimer");
    } else {
      log("Fill home ID to be navigated to home");
    }
  };

  const callBackAfterHomeId = (homeName) => {
    log("You are navigated to Home: " + homeName);
  };

  const callbackHome = () => {
    log("Home data sent");
  };

  // PRD: https://inclykkapp.grand-app.com/htmlLocal/grand-app/flutter_web/web/index.html
  // QA: https://inclykkqa.grand-app.com/htmlLocal/grand-app/flutter_web/web/index.html
  const createAnIframe = (divToLoadIframe, callbackAfter, myDomainPrm) => {
    divToLoadIframe.innerHTML = '<iframe id="seniormaticsapilauncher" src="https://inclykkapp.grand-app.com/htmlLocal/grand-app/flutter_web/web/index.html?url_from_server" style="position:absolute;width:100%;height:100%;margin:0;border:0;frameborder:0;"></iframe>';
	    const iframeElement = divToLoadIframe.querySelector('iframe');
    iframeRef.current = iframeElement;
    callbackTypes.callbackAfterLoginScreenLoaded = callbackAfter;

    window.addEventListener("message", callbackForAllCallsFromIframe, false);

    myDomain = myDomainPrm;


    setIframeLoaded(true); //  ensure iframe is loaded before trying to communicate

  };

  useEffect(() => {
    if (userRole?.find(item => item.privilege === "Read")){
      if(iframeLoaded){ //only start once the iframe has been added
        sendCallFromDomain(myDomain);
      }
    }
  }, [iframeLoaded]);

  


  const sendCallFromDomain = (myDomain) => {

    if (iframeRef.current && iframeRef.current.contentWindow) {
      iframeRef.current.contentWindow.postMessage({ callFromDomain: myDomain }, "https://inclykkqa.grand-app.com");
    } else {
      setTimeout(() => {
        sendCallFromDomain(myDomain);
      }, 30);
    }
  };

  const callbackForAllCallsFromIframe = (e) => {
    if (e.data != null) {
      if (e.data.seniorMaticsLoaded === true) {
        sendCallFromDomain(myDomain);
      } else if (e.data.loginPageLoaded === true) {
        callbackTypes.callbackAfterLoginScreenLoaded(e.data.clientId);
        onLogin();
      } else if (e.data.onRegisterApplied === true) {
        callbackTypes.callbackAfterLoginSuccess(e.data.result);
        getPasscodeByEmail();
      } else if (e.data.onPasscodeApplied === true) {
        callbackTypes.callbackAfterPasscodeSuccess(e.data.result);
      } else if (e.data.afterShowHomeId === true) {
        callbackTypes.callbackAfterNavigateToHome(e.data.result);
      }
    }
  };


  const loginToSeniorMatics = (username, phoneOrEmail, callback) => {

    if (iframeRef.current && iframeRef.current.contentWindow) {
      iframeRef.current.contentWindow.postMessage({ username: username, phoneOrEmail: phoneOrEmail }, "https://inclykkqa.grand-app.com");
      callbackTypes.callbackAfterLoginSuccess = callback;
    }

  };


  const loginWithPasscodeToSeniorMatics = (passcode, callback) => {
    if (iframeRef.current && iframeRef.current.contentWindow) {
      iframeRef.current.contentWindow.postMessage({ passcode: passcode }, "https://inclykkqa.grand-app.com");
      callbackTypes.callbackAfterPasscodeSuccess = callback;
    }

  };


  const navigateToHome = (homeId, callback) => {
    if (iframeRef.current && iframeRef.current.contentWindow) {
      iframeRef.current.contentWindow.postMessage({ navigateHomeId: homeId }, "*");
      callbackTypes.callbackAfterNavigateToHome = callback;
    }

  };

  const getPasscodeByEmail = async () => {
    var useremail = document.getElementById("loginContact").value;
    try {
        const response = await axios.get(`${AWS_SERVER_APIS_issue}/getgrandapppasscode`, {
            params: {
                email: useremail
            }
        });
        console.error('Response ---> '+response.data.passcode); // Assuming the response contains the passcode
        setPasscode(response.data.passcode);
        loginWithPasscodeToSeniorMatics(response.data.passcode, callbackPasscode);
    } catch (error) {
        console.error('Error fetching passcode:', error);
    }
  };

  useEffect(() => {
    if (userRole?.find(item => item.privilege === "Read")){
      let loginuser = localStorage.getItem("user");
      loginuser = JSON.parse(loginuser);
      setLoginUsername(loginuser.first_name);
      setLoginContact(loginuser.email);
      start();
    }else{
      alert('Insufficient Permissions for Behaviour & Monitoring Module');
    }
  }, []);


  return (
    <div className="container1">
      <div id="testDiv" ref={testDivRef} style={{width:"100%"}}></div>
      <div className="section" style={{display:"none"}}>
        <strong>Status / Logs:</strong>
        <div id="logBox">
          {logMessages.map((message, index) => (
            <div key={index}>{message}</div>
          ))}
        </div>
      </div>

      <div style={{ textAlign: 'center', marginTop: '20px', marginBottom: '20px', display:"none"}} >
        <button onClick={start}>Launch</button>
      </div>

      <div className="section" style={{display:"none"}}>
        <label>Login Username:</label>
        <input type="text" id="loginUsername" value={loginUsername} />
        <label>Phone or Email:</label>
        <input type="text" id="loginContact" value={loginContact} />
        <button onClick={onLogin}>Login</button>
      </div>

      <div className="section" style={{display:"none"}}>
        <label>Passcode:</label>
        <input type="text" id="passcodeField" value={passcode} />
        <button onClick={onPasscode}>Passcode</button>
      </div>

      <div className="section" style={{display:"none"}}>
        <label>Home ID:</label>
        <input type="text" id="homeIdField" value={homeId} onChange={(e) => setHomeId(e.target.value)} />
        <button onClick={onGoHome}>Go to Home</button>
      </div>
    </div>
  );
}

export default App;